import list from 'modules/payment/list/paymentListReducers';
import destroy from 'modules/payment/destroy/paymentDestroyReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  destroy,
});
